import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'

const LabelRequiredWrapper = styled.span`
  display: inline-block;
  width: 28px;
  height: 17px;
  line-height: 17px;
  color: ${Colors.white};
  font-size: ${fontSize.small}px;
  font-weight: bold;
  text-align: center;
  border-radius: ${borderRadius}px;
  ${mediaMin.phone`
    width:32px;
    height: 20px;
    line-height: 20px;
    font-size: ${fontSize.small_2}px;
    ${props =>
      props.minimize &&
      css`
        width: 28px;
        height: 17px;
        line-height: 17px;
        font-size: ${fontSize.small}px;
      `}
  `} ${({ required }) => css`
    background-color: ${required ? Colors.red : Colors.gray9};
  `};
`
type PropTypes = {
  required?: boolean,
  minimize?: boolean,
}

export default function LabelRequired(props: PropTypes) {
  return (
    <LabelRequiredWrapper required={props.required} minimize={props.minimize}>
      {props.required
        ? i18n.t('page.shared.requiredLabel.required')
        : i18n.t('page.shared.requiredLabel.optional')}
    </LabelRequiredWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/LabelRequired/index.jsx